import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import postalCodes from 'postal-codes-js';

var validateZipcode = function validateZipcode(zipCode, marketIso) {
  var isValid = postalCodes.validate(marketIso, zipCode);

  if (isValid === true) {
    return isValid;
  }

  return false;
};

export default validateZipcode;